import register from '../../../start/init/register/'
import component from './component/'
import { reactive } from '@vue/composition-api'

export const state = reactive({
  searches: [],

  query: ``
})

export default () => {

  const methods = {
    add: ({ route: _route, label }) => {
      const instance = state.searches.find(({ name }) => _route.name === name)

      if (instance) {
        return instance
      }

      const route = {
        name: `${_route.name}Search`,
        path: `${_route.path}search/:query?/`
      }

      register({
        pages: {
          [route.name]: {
            ...component,
            name: route.name,
            path: route.path
          }
        }
      })

      state.searches.push({
        route,
        label
      })
      return {
        route,
        label
      }
    }
  }

  return {
    ...methods
  }
}
